const categories = [
  {
    name: 'Asertivitate și managementul conflictelor',
    category: 'One',
    status: 'Publicată',
  },
  {
    name: 'Asertivitate și managementul conflictelor',
    category: 'One',
    status: 'Publicată',
  },
  {
    name: 'Asertivitate și managementul conflictelor',
    category: 'One',
    status: 'Publicată',
  },
  {
    name: 'Asertivitate și managementul conflictelor',
    category: 'One',
    status: 'Publicată',
  },
  {
    name: 'Asertivitate și managementul conflictelor',
    category: 'One',
    status: 'Publicată',
  },
  {
    name: 'Asertivitate și managementul conflictelor',
    category: 'One',
    status: 'Publicată',
  },
]

export const useData = () => categories
